

/* slider */
const swiper = new Swiper(".swiper", {
    loop: true,
    loopAdditionalSlides: 1,
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 0,
    speed: 800, // 移動速度
    breakpoints: {
      1000: {
        slidesPerView: 1,
        spaceBetween: 0
      }
    },
    autoplay: {
     delay: 6000,
      disableOnInteraction: false
    },
    slidesPerGroup: 1,
    initialSlide: 0,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets'
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
});
